import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../store';

interface ShowToRoleProps {
    allowedRoles: string[],
    children?: any,
}

const findOne = (haystack: string[], arr: string[]) => {
    return arr.some(v => haystack.includes(v));
};

const filterRoles = (allowed?: string[], existing?: string[]) => {
    if (!allowed || !existing) { return false; }
    return findOne(existing, allowed);
};
const ShowToRole = (props: ShowToRoleProps) => {
    const { state } = useContext(AppContext);
    const [show, setShow] = useState(false);

    useEffect(() => {
        const hasRole = filterRoles(state.orgInfo.roles?.split(','), props.allowedRoles);
        setShow(hasRole);
    },
        [state.orgInfo.roles, props.allowedRoles]);
    if (show) {
        return props.children;
    } else {
        return null;
    }
}
export default ShowToRole;